import { render, staticRenderFns } from "./DeleteIntroSlide.vue?vue&type=template&id=545e0cb0"
import script from "./DeleteIntroSlide.vue?vue&type=script&lang=js"
export * from "./DeleteIntroSlide.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports